import type { FaireProductEntity } from "../../entity_types/product";

export const p_f2vgrthtn9: FaireProductEntity = {
  token: "p_f2vgrthtn9",
  type: "product",
  name: "Pearl Jewel Embellished Fleece Lining Knit Beanie Hat",
  brandToken: "b_c3xmn96nkh",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/44d774762ae71ab2544bd0f88baa83e8131afeb775b2edc63199fa8d27f61c77.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ad3a4ab87d74057934221225e767d281d4a3972f970a4832dcc252a2c0aa77a8.jpeg",
    "https://cdn.faire.com/fastly/366741235f20823fbc4b7f30aeddae743ffc6a7dd129b9725498ab14941fb490.jpeg",
    "https://cdn.faire.com/fastly/e9faa3834b96b7222d3dfe1b0c1a35d4bb870ea1682943c4e27bad2918298083.jpeg",
    "https://cdn.faire.com/fastly/1402d511c43f2c9453ffad12ee15a5b5b6a2d44f54b591a3430b07e671f3f9b9.jpeg",
    "https://cdn.faire.com/fastly/aaca7dc1eae10d2ade1e5b3f1862496c28c9453ee0a35bb0732f7bb272629d93.jpeg",
    "https://cdn.faire.com/fastly/c57556c55794ea231e1c1fffd40ff45e1ed6637750514e29cbfd69ec21ba3deb.jpeg",
    "https://cdn.faire.com/fastly/4acd7662162914313e08981e25ef9b7284403db0bbeb00bc6f109ad9adb04b13.jpeg",
    "https://cdn.faire.com/fastly/a5a2f4f9bb6564683aeb41ec6f849f4204cc3b09ce625ff5c47f89ea090c6b3f.jpeg",
    "https://cdn.faire.com/fastly/cee264a62b400156add439d6fec34c3336b0ee8d89a5d7a105ff063ff490f9a9.jpeg",
    "https://cdn.faire.com/fastly/238ec6bc061dafd55585548f127fe49854792388653eb6d0afe83ecb2da432d3.jpeg",
  ],
  priceDollars: 9.15,
  description:
    "• Size : One Size\n• Material : 50% Polyester, 50% Acrylic\n• Trendy knit beanie adorned with sparkling rhinestones and pearl accents. A chic winter accessory that keeps you warm while adding glam to casual outfits, outdoor looks, and seasonal cold-weather wear.",
  tags: [],
  msrpDollars: 18.29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:31.575Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
